import { render, staticRenderFns } from "./License.vue?vue&type=template&id=1fc3c61c&scoped=true"
import script from "./License.vue?vue&type=script&lang=js"
export * from "./License.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc3c61c",
  null
  
)

export default component.exports